import VuexVueEvents from '@cm-frontend/commons/src/maker/store/events.js';

export default function ($store, $root) {
  VuexVueEvents($store, $root);
  // Extends
}
